import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import LoadingPlugin from './plugins/loading'
import '@/utils/flexiable'
import '@/assets/normalize.css'
import '@/assets/common.css'
import 'element-plus/dist/index.css'
import 'vant/lib/index.css';
import Toast from '@/components/Toast/index.vue'
import log from '@/plugins/log'
const isDev = process.env.NODE_ENV === 'development'
if (isDev) {
  console.log('isDev', isDev)
  window.f = x => x / 1624 * 750
}
const init = () => {
  const app = createApp(App)
  app.use(store).use(router).use(i18n).use(LoadingPlugin).use(log)

  // 注册Toast组件为全局组件
  app.component('Toast', Toast)

  app.mount('#app')
}
init()
